import { ColumnDef } from '@tanstack/react-table'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'

import { HiddenColumn, LastModifiedCell } from 'components/Table'
import { COLUMN_SIZE } from 'components/Table/constants'
import { AdUnitsForTable, UseColumnsProps } from '../types'
import { createEnableBidderColumns } from './createEnableBidderColumns'
import { createParamsColumns } from './createParamsColumns'

export const useColumns = ({
  cs: { csParams, csRequiredParamsNames },
  s2s: { s2sParams, s2sRequiredParamsNames },
  workspaceStatus,
}: UseColumnsProps): ColumnDef<AdUnitsForTable>[] => {
  const { t } = useTranslation(['features/globalSetup'], {
    keyPrefix: 'prebid.bidders.edit.bidParamsAndConnection.adUnitsTable',
  })

  const bidderColumns: ColumnDef<AdUnitsForTable> = createEnableBidderColumns({
    cs: { csRequiredParamsNames },
    s2s: { s2sParams, s2sRequiredParamsNames },
    workspaceStatus,
  })

  const csParamsColumns: ColumnDef<AdUnitsForTable> = _.isEmpty(csParams)
    ? HiddenColumn<AdUnitsForTable>()
    : createParamsColumns({
        kind: 'cs',
        params: csParams,
      })

  const s2sParamsColumns: ColumnDef<AdUnitsForTable> = _.isEmpty(s2sParams)
    ? HiddenColumn<AdUnitsForTable>()
    : createParamsColumns({
        kind: 's2s',
        params: s2sParams,
      })

  return [
    {
      columns: [
        {
          accessorKey: 'adUnit.path',
          header: t('adUnits.adUnitPath'),
          size: COLUMN_SIZE.LG,
        },
        {
          accessorKey: 'adUnit.divId',
          header: t('adUnits.divId'),
          size: COLUMN_SIZE.MD,
        },
      ],
      header: t('adUnits.group'),
      meta: { isPinned: true },
    },
    bidderColumns,
    csParamsColumns,
    s2sParamsColumns,
    {
      accessorKey: 'updatedAt',
      cell: props => <LastModifiedCell {...props} />,
      header: t('lastModified'),
    },
  ]
}
